import { Link } from "@tanstack/react-router";
import { Lock } from "lucide-react";
import { cn } from "@/lib/utils";

export function PrivacyBadge({ className }: { className?: string }) {
  return (
    <Link
      to="/privacy"
      hash="training"
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border border-border bg-muted/40 px-3 py-1 text-xs text-muted-foreground transition hover:border-primary/40 hover:text-foreground",
        className,
      )}
    >
      <Lock className="h-3.5 w-3.5 text-primary" />
      Your data is private · Never used for training
    </Link>
  );
}
